import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { asyncErrorHandler } from '../../utils/async-error-handler';
import { arrayFaqSchema } from './faq.schema';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosTokenInst = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_FAQ_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosTokenInst);

export const useGetFaqs = () => {
  return useQuery({
    queryKey: ['get-faqs'],
    queryFn: asyncErrorHandler(async () => {
      const response = await axiosTokenInst.get(`faq?faq_type=2`);
      const data = arrayFaqSchema.parse(response?.data?.data);
      return data;
    }),
  });
};
